var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBehance(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_64_35)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.8592 0.405273H3.14041C1.62957 0.405273 0.404785 1.63005 0.404785 3.1409V20.8578C0.404785 22.3686 1.62957 23.5934 3.14041 23.5934H20.8592C22.37 23.5934 23.5948 22.3686 23.5948 20.8578V3.1409C23.5948 1.63005 22.37 0.405273 20.8592 0.405273Z",
    fill: "#1769FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.86801 11.3025C9.86801 11.3025 11.8368 11.1562 11.8368 8.84809C11.8368 6.53996 10.2261 5.41309 8.18613 5.41309H1.47363V18.3131H8.18613C8.18613 18.3131 12.283 18.4425 12.283 14.505C12.283 14.505 12.463 11.3025 9.86801 11.3025ZM4.43051 7.70621H8.18051C8.18051 7.70621 9.09363 7.70621 9.09363 9.04871C9.09363 10.3912 8.55738 10.5862 7.94801 10.5862H4.43238L4.43051 7.70621ZM8.01176 16.02H4.43238V12.5737H8.18238C8.18238 12.5737 9.54176 12.555 9.54176 14.3456C9.54551 15.8362 8.55176 16.005 8.01363 16.02H8.01176ZM17.7486 8.69621C12.7874 8.69621 12.793 13.6518 12.793 13.6518C12.793 13.6518 12.4518 18.5831 17.7486 18.5831C17.7486 18.5831 22.1624 18.8343 22.1624 15.1537H19.8936C19.8936 15.1537 19.9686 16.5412 17.8311 16.5412C17.8311 16.5412 15.5605 16.6931 15.5605 14.2912H22.2449C22.2449 14.2912 22.9705 8.69621 17.7486 8.69621ZM19.7661 12.5737H15.5286C15.5286 12.5737 15.8061 10.5862 17.7993 10.5862C19.7924 10.5862 19.7661 12.5737 19.7661 12.5737ZM14.9736 6.17434H20.2949V7.76246H14.9736V6.17434Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_64_35"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBehance);
export default __webpack_public_path__ + "static/media/behance.ac862a13237e1814695e022af33883bd.svg";
export { ForwardRef as ReactComponent };